import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
    dialogWrapper: {
        zIndex: 999999,
        "& .MuiDialog-paperWidthSm": {
            width: "inherit",
            borderRadius: 10,
            margin: 10,
            maxWidth: "inherit",
        },
    },
    dialogTitle: {
        padding: "24px",
    },
    dialogContentWrapper: {
        padding: "0 12px",
    },
    dialogActionWrapper: {
        padding: "16px 24px",
    },
    headerTitle: {
        fontWeight: 500,
        fontSize: "20px",
        color: "rgb(36,42,56)",
    },
    boxHeader: {
        fontSize: "14px",
        color: "#a0acbc"
    },
    boxOuter: {
        border: "1px solid #c7d0db",
        borderRadius: "6px",
        padding: "5px 10px"
    },
    statusBoxOuter: {
        textAlign: 'right'
    },
    statusBoxInner: {
        display: "inline-block",
        borderRadius: "16px 0px 0px 16px",
        padding: "8px 16px",
        marginRight: "-16px"
    },
    statusClaimed: {
        background: "#e5f5ff",
    },
    statusApproved: {
        background: "#efffe5",
    },
    statusRejected: {
        background: "#fff4e5",
    },
    buttonOuterBox: {
        textAlign: "end",
        padding: "16px 0"
    },
    noBackground: {
        backgroundColor: "transparent",
        marginRight: "16px"
    },
    deleteView: {
        // width: "150px",
        marginLeft: "8px !important",
        "& .MuiButton-label": {
            padding: "16px",
        }
    },

    tripsListItem: {
        padding: theme.spacing(1.5),
        cursor: 'pointer',
    },
    tripsListItemSelected: {
        backgroundColor: 'rgba(255,212,40,.10)'
    },
    tripsListItemRow: {
        display: 'flex'
    },
    tripsListItemRowCenter: {
        alignItems: 'center',
        paddingLeft: '16px',
    },
    tripsListItemIconBox: {
        marginTop: theme.typography.pxToRem(2)
    },
    tripsListItemIconStart: {
        width: theme.typography.pxToRem(12),
        height: theme.typography.pxToRem(12),
        background: 'rgb(237,244,251)',
        borderRadius: theme.typography.pxToRem(12),
    },
    tripsListItemIconEnd: {
        width: theme.typography.pxToRem(12),
        height: theme.typography.pxToRem(12),
        background: 'rgb(237,244,251)'
    },
    dottedLine: {
        borderLeft: '3px dashed',
        borderColor: 'rgb(237, 244, 251)',
        marginLeft: '4px',
        marginTop: '1px',
        height: '75%',
    },
    tripsListItemSideBox: {
        padding: theme.spacing(0, 0, 1, 0.5)
    },
    eventAddress: {
        fontSize: theme.typography.pxToRem(12),
        fontWeight: 700,
        color: 'black'
    },
    eventNoAddress: {
        fontSize: theme.typography.pxToRem(12),
        fontWeight: 700,
        color: 'rgb(177,177,177)'
    },
    eventDate: {
        fontSize: theme.typography.pxToRem(10),
        color: 'rgb(177,177,177)'
    },
    eventsSeverityIcon: {
        margin: theme.spacing(0, 1, 0, 2)
    },
    eventsIcon: {
        width: theme.typography.pxToRem(15),
        height: theme.typography.pxToRem(15),
    },
    eventsSeverityCount: {
        fontSize: theme.typography.pxToRem(12),
        fontWeight: 500,
        color: 'rgb(146, 146, 146)',

    },
    eventsType: {
        backgroundColor: 'rgb(222,205,254)',
        fontSize: theme.typography.pxToRem(14),
        fontWeight: 700,
        padding: theme.spacing(0, 0, 0, 2),
        borderRadius: '18px',
        whiteSpace: 'nowrap',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        overflow: 'hidden',
    },
    eventsTypeButton: {
        padding: theme.spacing(1, 2),
        background: '#F9D13B'
    },
    reclassifyTrips: {
        margin: theme.spacing(1, 0),
    },
    mileageClaimBox: {
        width: "400px",
        padding: "0 12px"
    },
    showTripsBox: {
        width: "350px",
        padding: "0 12px"
    },
    mainDivider: {
        backgroundColor: "#c7d0db",
        width: "2px",
    },
    loaderHeader: {
        display: "flex",
        alignItems: "center"
    },
    horizontalDivider: {
        height: "1px",
        backgroundColor: "#c7d0db",
    }
}));